(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Laedt eine JS-Datei robust gegen Script-Stripper:
  //  1) per src-Element injizieren. Wird das Element entfernt (MutationObserver-
  //     Stripper) oder laedt es nicht, faellt es auf fetch()+eval zurueck.
  function fetchEval(src) {
    return fetch(src).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' für ' + src);
      return r.text();
    }).then(function (code) {
      // Globaler eval -> der UMD-Build setzt window.maplibregl bzw. der
      // Locator-IIFE läuft im globalen Scope.
      (0, eval)(code);
    });
  }

  function ensure(src) {
    return new Promise(function (resolve, reject) {
      var done = false;
      function finish(ok) {
        if (done) return;
        done = true;
        if (ok) { resolve(); return; }
        fetchEval(src).then(resolve, reject); // Fallback
      }
      var s = document.createElement('script');
      s.src = src;
      s.async = false; // Reihenfolge wahren: MapLibre vor Locator
      s.setAttribute('data-sl-loaded', src);
      s.onload = function () { finish(true); };
      s.onerror = function () { finish(false); };
      (document.head || document.documentElement).appendChild(s);
      // Hat ein Stripper das Element gleich wieder entfernt? -> Fallback
      setTimeout(function () { if (!done && !s.isConnected) finish(false); }, 250);
      // Sicherheitsnetz, falls weder load noch error feuert
      setTimeout(function () { if (!done) finish(false); }, 12000);
    });
  }

  function boot() {
    var root = document.querySelector('[data-store-locator]');
    if (!root) return;
    if (window.maplibregl && window.__slAppLoaded) {
      // Schon initialisiert -> nur neu rendern (Editor/Re-Render)
      root.dispatchEvent(new Event('sl-reinit', { bubbles: true }));
      return;
    }
    if (root.dataset.slBooting) return;
    root.dataset.slBooting = '1';
    var mapUrl = root.getAttribute('data-sl-maplibre');
    var appUrl = root.getAttribute('data-sl-app');
    if (!mapUrl || !appUrl) { console.error('[store-locator] Asset-URLs fehlen'); return; }
    console.log('[store-locator] Loader aktiv (inline), lade MapLibre …');
    ensure(mapUrl)
      .then(function () {
        // Falls onload zwar feuerte, der Build sich aber als AMD-Modul
        // registriert hat: über fetch+eval erzwingen.
        if (typeof window.maplibregl === 'undefined') {
          console.log('[store-locator] maplibregl noch undefined → fetch+eval');
          return fetchEval(mapUrl);
        }
      })
      .then(function () {
        console.log('[store-locator] MapLibre bereit, maplibregl =', typeof window.maplibregl);
        return ensure(appUrl);
      })
      .then(function () {
        window.__slAppLoaded = true;
        console.log('[store-locator] fertig.');
      })
      .catch(function (e) { console.error('[store-locator] Fehler:', e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Shopify Theme-Editor: nach Re-Render der Section erneut anstoßen
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
